import { render } from "./RengongYlqRwshuiyin.vue?vue&type=template&id=47c587d9"
import script from "./RengongYlqRwshuiyin.vue?vue&type=script&lang=js"
export * from "./RengongYlqRwshuiyin.vue?vue&type=script&lang=js"

import "./RengongYlqRwshuiyin.vue?vue&type=style&index=0&id=47c587d9&lang=css"

import exportComponent from "F:\\allNewWeb\\ant-vue\\antd-demo2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__